<template>
<div>
  <Prohead></Prohead>
  <Proadd></Proadd>
</div>
</template>

<script>
import Prohead from '../components/Prohead'
import Proadd from '../components/Proadd'
export default {
  name: "add",
  components: {Proadd, Prohead}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/add.vue